import type * as React from 'react';
import { useState } from 'react';

import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { TextLink } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled, { css } from 'styled-components';

import SignUp from '@/shared/components/AuthForm/SignUp/SignupForm';

import SocialAuth from './SocialAuth';

const Wrapper = styled.div`
  border-radius: 15px;

  ${props => props.theme.breakpoints.up('md')} {
    width: 400px;
  }
  background: linear-gradient(
    163.68deg,
    rgba(77, 77, 77, 0.32) 14.79%,
    rgba(145, 145, 145, 0) 141.37%,
    rgba(44, 35, 15, 0.08) 141.37%
  );
  backdrop-filter: blur(30px);
`;

const SignupForm: React.FC<
  React.PropsWithChildren<{ wrapperClassName?: string; title?: string }>
> = ({ wrapperClassName, title }) => {
  const { t } = useTranslation();
  const [renderSocialAuth, setRenderSocialAuth] = useState(true);

  const toggleAuthMethod = () => {
    setRenderSocialAuth(!renderSocialAuth);
  };

  return (
    <Wrapper
      className={`relative px-20 py-32 sm:px-24 sm:py-48 rounded-10 ${wrapperClassName}`}
    >
      <h1 className="tw-font-pop text-24 leading-28 font-extrabold text-center text-white mb-24 relative">
        {title || t('REGISTER_FORM_TITLE')}
      </h1>

      {renderSocialAuth ? (
        <SocialAuth />
      ) : (
        <SignUp
          isDark
          renderLegalCheckbox={false}
          customLabelCta={t('START_FREE_TRIAL')}
        />
      )}

      <TextLink
        className="m-auto mt-16 w-full text-center"
        label={t(renderSocialAuth ? 'AUTH_WITH_EMAIL' : 'AUTH_WITH_SOCIALNET')}
        onClick={toggleAuthMethod}
      />
      <p
        className="w-full text-center max-w-280 m-auto font-nun font-normal text-11 leading-12 mt-24"
        css={css`
          color: #a0a7cb;
        `}
      >
        {t('AGREE_TYC')}{' '}
        <a className="underline text-inherit " href="/legal">
          {t('LINK_TYC')}
        </a>
      </p>
    </Wrapper>
  );
};

export default SignupForm;
